import { apiSlice } from "../api/apiSlice";

export const notificationApi = apiSlice.injectEndpoints({
  tagTypes: ["action"],
  endpoints: (builder) => ({
    allNotificationFetch: builder.mutation({
      query: (data) => ({
        url: "/apiV2/alert-list",
        method: "POST",
        body: data,
      }),
    }),
    getLatestNotification: builder.query({
      query: () => "/apiV2/latest-alert-list",
      providesTags: ["action"],
    }),
    notificationAction: builder.mutation({
      query: (data) => ({
        url: "/apiV2/action",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["action"],
    }),
  }),
});

export const {
  useAllNotificationFetchMutation,
  useGetLatestNotificationQuery,
  useNotificationActionMutation,
} = notificationApi;
